import React from 'react';
import { Button, Typography, Row, Col, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import bloom from "../assets/bloom-main.jpg";
import heroes from "../assets/heroes-cup.jpg";
import sponser from "../assets/sponser.jpg";
const { Title, Paragraph, Text } = Typography;

const EventSponsorPage = () => {
  const navigate = useNavigate();

  const events = [
    {
      id: 1,
      title: 'Bloom Day',
      description: 'Are you ready to make a difference in a cause that matters? Partner with us to support a company event from across the UAE. At a corporate, connect your valuable thought sport. Share that your compassion. At a day of recognition and unity — where workers day by day help will be on full show. Aid yourself and teammates, rendering and prove that every player is a hero. Sponsor a team today!',
      image: bloom
    },
    {
      id: 2,
      title: 'Heroes Cup',
      description: 'Are you ready to make a difference in a cause that brings together heroes and communities? Partner with us to support the UAE. At a pinnacle, connect your valuable thought sport. Share that your compassion. At a day of recognition and unity — where workers day by day help will be on full show. Aid yourself and teammates, rendering and prove that every player is a hero. Sponsor a team today! Aid yourself and teammates, rendering everyone that every player is a hero.',
      image: heroes
    }
  ];

  const reasons = [
    {
      title: 'Community Impact',
      description: 'Help make sports accessible to everyone — from youth tournaments to inclusive initiatives like Bloom Day.'
    },
    {
      title: 'Brand Visibility',
      description: 'Gain recognition through event banners, team jerseys, social media promotion, and live mentions during tournaments.'
    },
    {
      title: 'Engagement',
      description: 'Show your company\'s commitment to social development, youth empowerment, and community well-being.'
    },
    {
      title: 'Networking',
      description: 'Connect directly with players, fans, and families in a positive, community-driven environment.'
    }
  ];

  const handleStartConversation = () => {
    navigate('/chat');
  };

  const handleSponsorEvent = (eventTitle) => {
    // Navigate to chat and optionally pre-fill a message about the specific event
    navigate('/chat', { 
      state: { 
        prefillMessage: `I'm interested in sponsoring the ${eventTitle} event. Can you provide more details?` 
      } 
    });
  };

  return (
    <div style={{ minHeight: '100vh' }}>
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${sponser})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '600px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          padding: '40px 20px'
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }}
        />
        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: '800px' }}>
          <Title level={1} style={{ color: 'white', fontSize: '48px', marginBottom: '20px' }}>
            Sponsor An Event !
          </Title>
          <Paragraph style={{ color: 'white', fontSize: '16px', marginBottom: '30px' }}>
          Support local sports and community growth by sponsoring our upcoming tournaments and events.Your contribution helps us provide better facilities, empower young athletes and promote inclusivity through sports.
          </Paragraph>
           <Button
                type="primary"
                size="large"
                onClick={handleStartConversation}
                style={{
                  color:"black",
                  backgroundColor: "white",
                  borderColor: "#7e7e7eff",
                  alignSelf: "flex-start",
                }}
              >
                Start Conversation
              </Button>
        </div>
      </div>

      {/* Upcoming Events Section */}
      <div style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}>
        <Title level={2} style={{ marginBottom: '40px', fontSize: '32px' }}>
          Upcoming Events
        </Title>

        {events.map((event) => (
          <Card
            key={event.id}
            style={{
              marginBottom: '30px',
              border: '1px solid #e8e8e8',
              borderRadius: '8px'
            }}
            bodyStyle={{ padding: 0 }}
          >
            <Row gutter={0}>
              <Col xs={24} md={8}>
                <div
                  style={{
                    backgroundImage: `url(${event.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '250px',
                    width: '100%'
                  }}
                />
              </Col>
              <Col xs={24} md={16}>
                <div style={{ padding: '30px' }}>
                  <Title level={3} style={{ marginBottom: '15px', fontSize: '24px' }}>
                    {event.title}
                  </Title>
                  <Paragraph style={{ color: '#666', marginBottom: '20px', lineHeight: '1.8' }}>
                    {event.description}
                  </Paragraph>
                  <Button 
                    type="default" 
                    onClick={() => handleSponsorEvent(event.title)}
                    style={{ borderColor: '#52c41a', color: '#52c41a' }}
                  >
                    Sponsor this event
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>
        ))}

        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <Button 
            type="link" 
            onClick={handleStartConversation}
            style={{ fontSize: '16px' }}
          >
            See All Events
          </Button>
        </div>
      </div>

      {/* Why Sponsor Section */}
      <div style={{ padding: '60px 20px', backgroundColor: '#fafafa' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <Title level={2} style={{ marginBottom: '40px', fontSize: '32px' }}>
            Why Sponsor With Us ?
          </Title>

          <Row gutter={[0, 24]}>
            {reasons.map((reason, index) => (
              <Col xs={24} key={index}>
                <div style={{ textAlign: 'left' }}>
                  <Title level={4} style={{ fontSize: '20px', marginBottom: '10px', fontWeight: 600 }}>
                    • {reason.title}
                  </Title>
                  <Paragraph style={{ color: '#666', paddingLeft: '15px', fontSize: '16px', lineHeight: '1.8' }}>
                    {reason.description}
                  </Paragraph>
                </div>
              </Col>
            ))}
          </Row>

          {/* Additional CTA Section */}
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Title level={3} style={{ marginBottom: '20px' }}>
              Ready to Make an Impact?
            </Title>
            <Paragraph style={{ color: '#666', marginBottom: '30px', fontSize: '16px' }}>
              Start a conversation with our team to discuss sponsorship opportunities tailored to your business.
            </Paragraph>
            <Button
              type="primary"
              size="large"
              onClick={handleStartConversation}
              style={{
                color: "black",
                backgroundColor: "white",
                borderColor: "#7e7e7eff",
              }}
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSponsorPage;